import API from 'utils/api';
import { onError } from 'utils/handlers';
import { postArchivoDeComentarioDeTramite } from 'api/tramites/archivosDeComentarios';

export const baseURI = 'tramites/comentarios-de-tramites/';

/**
 * GET Comentarios de Tramite
 * param {object} params
 * @returns {Promise<object[]>}
 */
export const getComentariosDeTramites = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * POST Comentario de Tramite
  * @param {object} values
  * @param {string} values.comentario
  * @param {boolean} values.es_comentario_interno
  * @param {number} values.tramite
  * @param {File[]} values.archivos
 * @returns {Promise<object|boolean>}
 */
export const postComentarioDeTramite = async ({ archivos = [], ...values }) => {
  try {
    const response = await API.post(baseURI, values);
    const promises = archivos.map((archivo) => postArchivoDeComentarioDeTramite({
      archivo: archivo.originFileObj,
      comentario: response.data.id,
    }));
    const responses = await Promise.all(promises);
    if (!responses.every((r) => r)) {
      onError({ data: { detail: 'Ha ocurrido un error intentelo de nuevo' } });
      return false;
    }
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
